import { GalleryPlayground } from "../demos/GalleryPlayground";

// The primary demo surface: the curated-gallery slider playground.
export function DemoPage() {
  return (
    <main className="wrap demo-page">
      <header className="demo-hero rise rise-1">
        <span className="eyebrow">Try it · no sign-in</span>
        <h1>
          Move the sliders. Watch the gallery decide what&apos;s an alert.
        </h1>
        <p>
          These are the exact controls a parent or accountability sponsor sets
          on each device — and the exact gating the on-device pipeline uses.
          Drag the sliders and the gallery reclassifies live, the same way it
          would on a real PC.
        </p>
        <div className="callout">
          <strong>Curated demo gallery — placeholder content.</strong> To keep
          this safe and abuse-free there are <em>no uploads here</em>, and these
          tiles are abstract placeholders with text labels only. The shipping
          demo runs on KinSafe&apos;s own pre-vetted, legally-sourced set
          spanning swimwear → suggestive → explicit. The behavior you see is
          real; the imagery is a stand-in.
        </div>
      </header>

      <div className="rise rise-2">
        <GalleryPlayground />
      </div>
    </main>
  );
}
